import * as t from "io-ts"

export const TDmpRecord = t.interface({
  airport: t.string,
  periodFrom: t.string,
  periodTo: t.string,
  disableNew: t.boolean,
  disableTimeChange: t.boolean,
  disableAcUpgrade: t.boolean
})

export const TDmpRecords = t.array(TDmpRecord)

export const TGetDmpRecordsResult = t.interface({
  dmpRecords: TDmpRecords
})

export type DmpRecord = t.TypeOf<typeof TDmpRecord>
export type DmpRecords = t.TypeOf<typeof TDmpRecords>
